// @flow
import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { SubscriptionInfo as SubscriptionInfoView } from '@views';
import { getActiveSubscriptionUserInfo, newBoleto, openWebBilling } from '@context/subscription';
import type { User, SubscriptionState, BundledPermissions } from '@types';
import { logout } from '@context/user';
import { mapBundledPermission } from '@helpers/connect';
import { router } from '@router';
import { isStoreReview } from '../redux/modules/appVersion';

type Props = {
  user: User,
  dispatch: Function,
  subscription: SubscriptionState,
  permissions: BundledPermissions,
  isRequestingNewBoleto: boolean,
  openingWebBilling: ?Object,
  storeReview: boolean,
};

class SubscriptionInfo extends React.Component<Props> {
  componentWillMount() {
    this.props.dispatch(getActiveSubscriptionUserInfo());
  }
  render() {
    const { user, subscription, isRequestingNewBoleto } = this.props;

    return (
      <SubscriptionInfoView
        user={user}
        subscription={subscription}
        onLogout={this.handleLogout}
        permissions={this.props.permissions}
        onGetNewBoleto={this.handleGetBoleto}
        isRequestingNewBoleto={isRequestingNewBoleto}
        onManageBilling={this.handleManageBilling}
        onUpdateCard={this.handleUpdateCard}
        openingBillingPage={get(this.props.openingWebBilling, 'destination', null)}
        onResubscribeClick={this.handleResubscribeClick}
        storeReview={this.props.storeReview}
      />
    );
  }
  handleLogout = () => this.props.dispatch(logout());

  handleGetBoleto = () => {
    this.props.dispatch(newBoleto());
  };

  handleManageBilling = () => {
    this.props.dispatch(openWebBilling('billing'));
  };

  handleUpdateCard = () => {
    this.props.dispatch(openWebBilling('new_card'));
  };

  handleResubscribeClick = () => {
    this.props.dispatch(router.pushPath('pricing'));
  };
}

const mapStateToProps = (state) => ({
  user: state.context.user,
  subscription: get(state, ['context', 'subscription'], {}),
  isRequestingNewBoleto: get(state, ['context', 'subscription', 'isRequestingNewBoleto'], false),
  openingWebBilling: get(state, ['context', 'subscription', 'openingWebBilling'], null),
  permissions: mapBundledPermission(state),
  storeReview: isStoreReview(state),
});

export default connect<any, any, any, any, any, any>(
  mapStateToProps,
)(SubscriptionInfo);
